import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL, DateFormat, DateTimeFormat } from "../Components/Constant";
import ApiService from "../Components/apiService";
import "react-data-grid/lib/styles.css";
import DataGrid, { TreeDataGrid } from "react-data-grid";
import _, { set } from "lodash";
import { Spin, Select, Card, Divider, Tabs, Row, Col, Switch, Tag, Button, Typography, Layout, message } from "antd";
import { UnorderedListOutlined, FilterFilled, FilterOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Bar, Pie, Line } from "@ant-design/charts"; // Import Ant Design Charts
import DynamicPicklistComponent from '../Components/MultiSelectPicklistComponent';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

const { TabPane } = Tabs;
const { Title } = Typography;
const { Header, Sider, Content } = Layout;

const DisplayReport = () => {
  const { id } = useParams();
  const [groupFields, setGroupFields] = useState(null);
  const [selectedGroupFields, setSelectedGroupFields] = useState([]);
  const [data, setData] = useState([]);
  const [objectName, setObjectName] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [aggregationFields, setAggregationFields] = useState([]);
  const [expandedGroupIds, setExpandedGroupIds] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [fields, setFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [reportName, setReportName] = useState("");
  const [showChart, setShowChart] = useState(false);
  const [chartName, setChartName] = useState("");
  const [filters, setFilters] = useState(null);
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [currency, setCurrency] = useState('');
  const [fieldsToDisplay, setFieldsToDisplay] = useState([]);
  const defaultCurrency = useSelector(state=>state.data.orgItem);
   
  const fetchOrgSetupDetails = async () => {
    
        setCurrency(defaultCurrency?.currency);
         
  };
    
      useEffect(() => {
        fetchOrgSetupDetails();
    
      }, []);

 
  useEffect(() => {
    console.log('fieldsad asfasfanfa',fields);
    // if(fields.length > 0){
      fetchReportData();
    // }
  }, [fields]);


  useEffect(() => {
    if (objectName) {
      fetchfields();
    }
  }, [objectName]);

  

  const fetchfields = async () => {
    setLoading(true);
    try {
      const apiServiceFields = new ApiService(
        `${BASE_URL}/mt_fields/object/${objectName}`,
        { "Content-Type": "application/json" },
        "GET"
      );

      const res = await apiServiceFields.makeCall();
      const excludedFieldNames = ["recordCount", "CreatedBy", "LastModifiedBy"];

      const filteredfieldNames = res.filter(
        (field) => !excludedFieldNames.includes(field.name)
      );
      setFields(filteredfieldNames);

      const fieldNames = res
        .filter((field) => !excludedFieldNames.includes(field.name))
        .map((field) => field.name);

      setSelectedFields(fieldNames);

      const columns = res
        ?.filter(
          (field) =>
            !["recordCount", "CreatedBy", "LastModifiedBy"].includes(field.name)
        )
        .map((field, index) => ({
          key: field.name,
          label: field.label,
          name: field.name,
          type: field.type,
          ...(field.type === "currency" && {
            renderCell: ({ row }) => {
              const value = row[field.name];
              const formattedValue = value % 1 !== 0
                ? Number(value).toFixed(2)
                : `${value}.00`; 
              return (
                <span >
                  {currency || '$'}{formattedValue}
                </span>
              );
            },
          }),
          ...(field.type === "decimal" && {
            renderCell: ({ row }) => {
              const value = row[field.name];
              const formattedValue = value % 1 !== 0
                ? Number(value).toFixed(2)
                : `${value}.00`; 
              return (
                <span >
                  {formattedValue}
                </span>
              );
            },
          }),
          ...(field.type === "integer" && {
            renderCell: ({ row }) => {
              return <span >{row[field.name]}</span>;
            },
          }),

          ...(field.name === "Name" && {
            renderCell: ({ row }) => {
              const redirectUrl = `/record/${objectName}/${row['_id']}`; // Replace with your URL
              const value=row[field.name];
              return (
                <span 
                  style={{ color: '#00A1E0', textDecoration: 'underline', cursor: 'pointer' }} 
                  onClick={() => window.location.href = redirectUrl}
                >
                  {value}
                </span>
              );
            },
          }),

          ...(field.type === "date" && {
            renderCell: ({ row }) => {
              const date = row[field.name]
              return <span >{date ? dayjs(date).format(DateFormat) : ''}</span>;
            },
          }),

          ...(field.type === "datetime" && {
            renderCell: ({ row }) => {
              const date = row[field.name]
              return <span >{date ? dayjs(date).format(DateTimeFormat) : ''}</span>;
            },
          }),

          ...(field.type === "lookup" && {
            renderCell: ({ row }) => {
              const fieldName = field.name;
              const parentObjectName = field?.parent_object_name;
            
              // Support multiple structures: object with _id, object in *_object, or string
              const rawValue = row[fieldName];
              const objectValue = typeof rawValue === "object" && rawValue !== null
                ? rawValue
                : row[`${fieldName}_object`] ?? null;
            
              const parentRecordId = objectValue?._id;
              const name = typeof rawValue === "string"
                ? rawValue
                : objectValue?.Name || rawValue?.Name || "N/A";
            
              const redirectUrl = parentRecordId && parentObjectName
                ? `/record/${parentObjectName}/${parentRecordId}`
                : null;
            
              return (
                <span
                  style={{
                    color: redirectUrl ? "#00A1E0" : undefined,
                    textDecoration: redirectUrl ? "underline" : undefined,
                    cursor: redirectUrl ? "pointer" : undefined,
                  }}
                  onClick={() => redirectUrl && window.open(redirectUrl, "_blank")}
                >
                  {name}
                </span>
              );
            }
            
          }),

          ...(field.type === "address" && {
            renderCell: ({ row }) => {
              const address = row[field.name]; // Access the address object
              if (address) {
                // Destructure and combine address fields into a single string
                const { street, city, state, country, postal_code } = address;
                const formattedAddress = [street, city, state, country, postal_code]
                  .filter(Boolean) // Filter out empty or undefined values
                  .join(", "); // Join non-empty fields with a comma
                return <span>{formattedAddress}</span>;
              }
              // Fallback if address is missing
              return <span></span>;
            },
          }),

          ...(index === 0 // Check if this is the first column
            ? {
              renderSummaryCell: ({ row }) => {
                return (
                  <span style={{ fontWeight: 500 }}>
                    Total {row.totalCount} records
                  </span>
                );
              },

            }
            : {
              ...(aggregationFields.includes(field.name) && {
                renderGroupCell: ({ childRows }) => {
                  const sum = childRows.reduce(
                    (prev, row) => prev + (Number(row[field.name]) || 0),
                    0
                  );
                
                  // Check if the field type is "currency" and format accordingly
                  if (field.type === "currency" || field.type === "decimal") {
                    const formattedSum = sum % 1 !== 0
                      ? Number(sum).toFixed(2)  // Format to 2 decimal places if necessary
                      : `${sum}.00`;  // Add .00 if no decimal places
                    return <span>{currency || '$'}{formattedSum}</span>;
                  }
                
                
                  // Return the normal sum if it's not "currency"
                  return <span >{sum}</span>;
                },

                renderSummaryCell: ({ row }) => {
                  if (field.type === "currency") {
                    const value = row[field.name];
                    const formattedValue = value % 1 !== 0
                      ? Number(value).toFixed(2)
                      : `${value}.00`; 
                      return <span >{currency || '$'}{formattedValue}</span>;
                  }
                  else if (field.type === "decimal") {
                    const value = row[field.name];
                    const formattedValue = value % 1 !== 0
                      ? Number(value).toFixed(2)
                      : `${value}.00`; 
                      return <span >{formattedValue}</span>;
                  }
                  return <span >{row[field.name]}</span>; // Summing values for other columns
                },
              }),
            }),
        }));
        const filteredColumns = columns
          .filter((column) => fieldsToDisplay.includes(column.name))
          .sort((a, b) => fieldsToDisplay.indexOf(a.name) - fieldsToDisplay.indexOf(b.name));
      
        setColumns(filteredColumns);
    } catch (Error) {
    }
    finally{
      setLoading(false);
    }
  };

  const fetchReportData = async () => {
    setLoading(true);
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_reports/${id}`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const response = await apiService.makeCall();
      console.log("Report data response:", response);
      

      const filteredRowData = response?.data.map((record) => {
        const filteredRecord = {};
        Object.keys(record).forEach((key) => {
          filteredRecord[key] = record[key] === null ? "" : record[key];
        });
        return filteredRecord;
      });
      // const flattenedRowData = response?.data.map((record) => {
      //   const flattened = {};
      
      //   Object.entries(record).forEach(([key, value]) => {
      //     // Handle nulls
      //     if (value === null) {
      //       flattened[key] = "";
      //       return;
      //     }
      
      //     // If this is a lookup field (i.e. object with Name), flatten it
      //     const isLookup = fields?.find(f => f.name === key && f.type === "lookup");
      
      //     if (isLookup && typeof value === "object" && value?.Name) {
      //       flattened[key] = value.Name; // Flatten to Name directly
      //       // Optional: store the full object separately for later use (like redirect)
      //       flattened[`${key}_object`] = value;
      //     } else {
      //       flattened[key] = value;
      //     }
      //   });
      
      //   return flattened;
      // });
      
      const flattenedRowData = response?.data.map((record) => {
        const flattened = {};
      
        Object.entries(record).forEach(([key, value]) => {
          // Keep untouched by default
          flattened[key] = value;
      
          // Skip if value is null
          if (value === null) return;
      
          // Is this field a lookup AND used in group_fields?
          const isLookupField = fields?.find(f => f.name === key && f.type === "lookup");
          const isGroupedField = response?.report?.group_fields?.includes(key);
      
          if (isLookupField && isGroupedField && typeof value === "object" && value?.Name) {
            flattened[key] = value.Name; // Flatten only if in group_by
            flattened[`${key}_object`] = value;
          }
        });
      
        return flattened;
      });
      
      setRowData(flattenedRowData);
      
      // setRowData(filteredRowData);
      setGroupFields(response?.report?.group_fields);
      setData(response?.data);
      setObjectName(response?.report?.model);
      setFieldsToDisplay([
        ...(response?.report?.fields_to_display || []),
        ...(response?.report?.aggregation_fields || [])
      ]);
      setAggregationFields(response?.report?.aggregation_fields);
      setSelectedGroupFields(response?.report?.group_fields);
      setReportName(response?.report?.name);
      setChartName(response?.report?.chart_type);
      setFilters(response?.report?.filters);
    } catch (error) {
      console.error("Error fetching report data:", error);
      message.error("Error fetching report data: " + error.error || error.message);
    }
    finally{
      setLoading(false);
    }
  };

  const handleShowChart = (e) => {
    setShowChart(e);
  };

  const renderChart = () => {
    if (!selectedGroupFields.length || !aggregationFields.length) {
      return <p>Select a grouping field and an aggregation field and see the magic happens.</p>;
    }
    const chartData = rowData.map((row) => {
      const categoryField = selectedGroupFields[0];
      const aggregationField = aggregationFields[0];
      
      let categoryValue = row[categoryField];
      if (typeof categoryValue === 'object' && categoryValue !== null && categoryValue.Name) {
        categoryValue = categoryValue.Name;
      }

      return {
        category: categoryValue,
        value: row[aggregationField],
      };
    });
    const config = {
      data: chartData,
      xField: 'value',
      yField: 'category',
      autoFit: true,
      padding: "auto",
    };
    switch (chartName.toLowerCase()) {
      case "bar":
        return <Bar {...config} />;
      case "pie":
        return <Pie {...config} angleField="value" colorField="category" />;
      case "line":
        return <Line {...config} />;
      default:
        return <p>No chart type selected.</p>;
    }
  };

  function capitalizeFirstLetter(string) {
    if (!string) return ''; // Handle cases where the string is undefined or null
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const summaryRows = useMemo(() => {
    const totalCount = rowData.length;

    const aggregationSums = aggregationFields.reduce((sums, fieldName) => {
      const sum = rowData.reduce((acc, row) => acc + (Number(row[fieldName]) || 0), 0); // Ensure numbers
      sums[fieldName] = sum;
      return sums;
    }, {});

    return [
      {
        totalCount,
        ...aggregationSums, // Merge the sums into the summary row
      },
    ];
  }, [rowData, aggregationFields]);

  const mapOperator = (operator) => {
    switch (operator) {
      case "$gt":
        return ">";
      case "$gte":
        return ">=";
      case "$lt":
        return "<";
      case "$lte":
        return "<=";
      case "$ne":
        return "!=";
      case "contains":
        return "Contains";
      case "starts_with":
        return "startsWith";
      case "ends_with":
        return "endsWith";
      default:
        return operator; // Fallback for unknown operators
    }
  };

  const handleBack = () => {
    navigate(`/setup/Reports`);
  }

  const style = (
    <style jsx>{`
      .rdg-light {
        position: relative;
        overflow: auto;
      }

      .rdg-light:hover::-webkit-scrollbar {
        width: 6px; /* Makes the scrollbar thin */
        height: 6px; /* Optional for horizontal scrollbar */
      }

      .rdg-light::-webkit-scrollbar {
        width: 0px; /* Initially make scrollbar invisible */
        height: 0px; /* Optional for horizontal scrollbar */
      }

      .rdg-light::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 3px;
      }

      .rdg-light::-webkit-scrollbar-track {
        background: transparent;
      }
    `}</style>
  );

  return (
    <div >
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px",height:'40px'}}>
        <Title level={2}>{reportName}</Title>
        <Button onClick={handleBack}>Back</Button>
      </div>


      <div style={{ padding: "0px", display: "flex", marginTop: "0px", height: '100%' }}>
        <Layout style={{ background: '#fff' }}>
          <Sider
            trigger={null}
            key={collapsed ? "collapsed" : "expanded"}
            collapsible
            collapsed={collapsed}
            collapsedWidth={0}
            width={300}
            style={{ background: '#fff', border: "1px solid #ddd" }}>
            <div style={{ padding: "20px", flex: 2, }}>
              <Tabs defaultActiveKey="1">
                <TabPane
                  tab={
                    <span>
                      <UnorderedListOutlined style={{ marginRight: "2px" }} /> Outline
                    </span>
                  }
                  key="1"
                >
                  <Card>
                    <h3 style={{ marginTop: 0 }}>Group Rows</h3>
                    <Select
                      mode="multiple"
                      style={{ width: "100%" }}
                      placeholder="Select group fields"
                      value={selectedGroupFields}
                      onChange={setSelectedGroupFields}
                    >
                      {groupFields?.map((field) => (
                        <Select.Option key={field} value={field}>
                          {field}
                        </Select.Option>
                      ))}
                    </Select>
                  </Card>
                  <Divider style={{ border: "0.1px solid #ddd" }}></Divider>
                  <Card>
                    <h3 style={{ marginTop: 0 }}>Columns</h3>
                    <DynamicPicklistComponent
                      onChange={(selectedFields) => {
                        setFieldsToDisplay(selectedFields); // Update fieldsToDisplay state
                        const updatedColumns = selectedFields.map((fieldName, index) => {
                          const field = fields.find((f) => f.name === fieldName);
                          if (!field) return null;

                          return {
                            key: field.name,
                            label: field.label,
                            name: field.name,
                            type: field.type,
                            ...(field.type === "currency" && {
                              renderCell: ({ row }) => {
                                const value = row[field.name];
                                const formattedValue = value % 1 !== 0
                                  ? Number(value).toFixed(2)
                                  : `${value}.00`;
                                return (
                                  <span>
                                    {currency || "$"}
                                    {formattedValue}
                                  </span>
                                );
                              },
                            }),
                            ...(field.type === "decimal" && {
                              renderCell: ({ row }) => {
                                const value = row[field.name];
                                const formattedValue = value % 1 !== 0
                                  ? Number(value).toFixed(2)
                                  : `${value}.00`;
                                return <span>{formattedValue}</span>;
                              },
                            }),
                            ...(field.type === "integer" && {
                              renderCell: ({ row }) => <span>{row[field.name]}</span>,
                            }),
                            ...(field.name === "Name" && {
                              renderCell: ({ row }) => {
                                const redirectUrl = `/record/${objectName}/${row["_id"]}`;
                                const value = row[field.name];
                                return (
                                  <span
                                    style={{
                                      color: "#00A1E0",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => (window.location.href = redirectUrl)}
                                  >
                                    {value}
                                  </span>
                                );
                              },
                            }),
                            ...(field.type === "date" && {
                              renderCell: ({ row }) => {
                                const date = row[field.name];
                                return (
                                  <span>{date ? dayjs(date).format(DateFormat) : ""}</span>
                                );
                              },
                            }),
                            ...(field.type === "datetime" && {
                              renderCell: ({ row }) => {
                                const date = row[field.name];
                                return (
                                  <span>
                                    {date ? dayjs(date).format("DD/MM/YYYY hh:mm A") : ""}
                                  </span>
                                );
                              },
                            }),
                            ...(field.type === "lookup" && {
                              renderCell: ({ row }) => {
                                const fieldName = field.name;
                                const value = row[fieldName];

                                // Case 1: Already flattened string (e.g., "John Doe")
                                if (typeof value === "string") {
                                  return <span>{value || "N/A"}</span>;
                                }

                                // Case 2: Lookup object (e.g., { Name: "John Doe", _id: ... })
                                if (typeof value === "object" && value?.Name) {
                                  return <span>{value.Name}</span>;
                                }

                                // Case 3: Fallback to separate *_object field if available
                                const objectValue = row[`${fieldName}_object`];
                                if (objectValue?.Name) {
                                  return <span>{objectValue.Name}</span>;
                                }

                                // Default
                                return <span>N/A</span>;

                              },
                            }),
                            ...(field.type === "address" && {
                              renderCell: ({ row }) => {
                                const address = row[field.name];
                                if (address) {
                                  const { street, city, state, country, postal_code } = address;
                                  const formattedAddress = [street, city, state, country, postal_code]
                                    .filter(Boolean)
                                    .join(", ");
                                  return <span>{formattedAddress}</span>;
                                }
                                return <span></span>;
                              },
                            }),
                            ...(index === 0 // Check if this is the first column
                              ? {
                                renderSummaryCell: ({ row }) => {
                                  return (
                                    <span style={{ fontWeight: 500 }}>
                                      Total {row.totalCount} records
                                    </span>
                                  );
                                },

                              }
                              : {
                                ...(aggregationFields.includes(field.name) && {
                                  renderGroupCell: ({ childRows }) => {
                                    const sum = childRows.reduce(
                                      (prev, row) => prev + (Number(row[field.name]) || 0),
                                      0
                                    );
                                  
                                    // Check if the field type is "currency" and format accordingly
                                    if (field.type === "currency" || field.type === "decimal") {
                                      const formattedSum = sum % 1 !== 0
                                        ? Number(sum).toFixed(2)  // Format to 2 decimal places if necessary
                                        : `${sum}.00`;  // Add .00 if no decimal places
                                      return <span>{currency || '$'}{formattedSum}</span>;
                                    }
                                  
                                  
                                    // Return the normal sum if it's not "currency"
                                    return <span >{sum}</span>;
                                  },

                                  renderSummaryCell: ({ row }) => {
                                    if (field.type === "currency") {
                                      const value = row[field.name];
                                      const formattedValue = value % 1 !== 0
                                        ? Number(value).toFixed(2)
                                        : `${value}.00`; 
                                        return <span >{currency || '$'}{formattedValue}</span>;
                                    }
                                    else if (field.type === "decimal") {
                                      const value = row[field.name];
                                      const formattedValue = value % 1 !== 0
                                        ? Number(value).toFixed(2)
                                        : `${value}.00`; 
                                        return <span >{formattedValue}</span>;
                                    }
                                    return <span >{row[field.name]}</span>; // Summing values for other columns
                                  },
                                }),
                              }),
                            }; 
                        }).filter(Boolean);
                        setColumns(updatedColumns); // Update columns state
                      }}
                      isSelect={true}
                      selectedFields={fieldsToDisplay}
                      selectOptions={fields}
                    ></DynamicPicklistComponent>
                  </Card>
                </TabPane>

                <TabPane
                  tab={
                    <span >
                      <FilterFilled style={{ marginRight: '2px' }} /> Filters
                    </span>
                  } key="2">
                  <Card>
                    {filters && (
                      <>
                        <FilterOutlined style={{ fontSize: '14px', marginRight: 5 }} />
                        {Object.entries(filters)?.map(([key, condition]) => (
                          <div key={key} style={{ marginBottom: 5, display: 'block' }}> 
                            <Tag color="blue" style={{ display: 'block', width: 'fit-content' }}>
                              {condition?.field}{' '}
                              {typeof condition?.value === 'object'
                                ? Object.entries(condition?.value)
                                    .map(([operator, value]) => `${mapOperator(operator)} ${value}`)
                                    .join(', ')
                                : `= ${condition?.value?.toString()}`}
                            </Tag>
                          </div>
                        ))}
                      </>
                    )}
                  </Card>




                </TabPane>
              </Tabs>
            </div>
          </Sider>

          <Layout style={{ padding: "20px", paddingTop: "0px", flex: 7, width: '100px', border: "1px solid #ddd" }}>
            <Header
              style={{
                padding: 0,
                background: '#fff',
                height: '50px',
                marginBottom:'5px',
                marginTop:'5px'
              }}
            >
              <Row style={{ display: "flex", justifyContent: "space-between", marginBottom: '10px' }}>
                <Col>
                  <Button
                    type="text"
                    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    onClick={() => setCollapsed(!collapsed)}
                    style={{
                      fontSize: '16px',
                      width: 64,
                      height: 64,
                    }}
                  />
                </Col>

                <Col style={{ display: "flex", justifyContent: "flex-end", marginRight: '2-px' }}>
                  <span style={{ marginRight: '5px', padding: "auto", fontWeight: "500", fontSize: '18px' }}>Show Chart</span>
                  <Switch style={{ marginTop: 20, margin: 'auto' }} checked={showChart} onChange={handleShowChart}></Switch>
                </Col>
              </Row>


            </Header>
            <Content>
              <Card>
                {loading ? (
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <Spin size="large" />
                  </div>
                ) : (
                  <div style={{ height: '60vh', overflowY: 'hidden' }}>
                    {style}
                    <TreeDataGrid
                      columns={columns}
                      rows={rowData}
                      style={{ height: '60vh', overflowY: 'scroll' }}
                      // defaultColumnOptions={{
                      //   maxWidth: '100%',
                      //   resizable: true,
                      //   sortable: true,
                      //   draggable: true,
                      // }}
                      groupBy={selectedGroupFields}
                      renderers={{
                        // renderGroupCell: ({ column, childRows }) => {
                        //   const fieldName = column.key;
                        //   const fieldMeta = fields.find(f => f.name === fieldName);
                        //   const firstRow = childRows?.[0];
                    
                        //   if (fieldMeta?.type === "lookup") {
                        //     const lookupName = firstRow?.[fieldName] || "N/A";
                        //     const fullObject = firstRow?.[`${fieldName}_object`];
                        //     const parentObjectName = fieldMeta?.parent_object_name;
                        //     const redirectUrl = fullObject?._id
                        //       ? `/record/${parentObjectName}/${fullObject._id}`
                        //       : null;
                    
                        //     return (
                        //       <span
                        //         style={{
                        //           color: redirectUrl ? "#00A1E0" : undefined,
                        //           textDecoration: redirectUrl ? "underline" : undefined,
                        //           cursor: redirectUrl ? "pointer" : undefined,
                        //         }}
                        //         onClick={() => redirectUrl && window.open(redirectUrl, "_blank")}
                        //       >
                        //         {lookupName}
                        //       </span>
                        //     );
                        //   }
                        //   // if (fieldMeta?.type === "lookup") {
                        //   //   const lookupName = firstRow?.[fieldName] || "N/A"; // ← this is flattened value
                        //   //   const fullObject = firstRow?.[`${fieldName}_object`]; // ← this is actual object
                          
                        //   //   const parentObjectName = fieldMeta?.parent_object_name;
                        //   //   const redirectUrl = fullObject?._id
                        //   //     ? `/record/${parentObjectName}/${fullObject._id}`
                        //   //     : null;
                          
                        //   //   return (
                        //   //     <span
                        //   //       style={{
                        //   //         color: redirectUrl ? "#00A1E0" : undefined,
                        //   //         textDecoration: redirectUrl ? "underline" : undefined,
                        //   //         cursor: redirectUrl ? "pointer" : undefined,
                        //   //       }}
                        //   //       onClick={() => redirectUrl && window.open(redirectUrl, "_blank")}
                        //   //     >
                        //   //       {lookupName}
                        //   //     </span>
                        //   //   );
                        //   // }
                          
                    
                        //   return <span>{firstRow?.[fieldName]}</span>;
                        // }
                        renderGroupCell: ({ column, childRows, groupKey }) => {
                          console.log('columncolumn:',column);
                          console.log('groupKey:', groupKey);
                          const fieldName = column.key;
                          const fieldMeta = fields.find(f => f.name === fieldName);
                        
                          // Helper function to check if value should be displayed as dash
                          const shouldShowDash = (value) => {
                            return value === null || 
                                   value === undefined || 
                                   value === '' ||
                                   value === 'null' ||
                                   value === 'undefined' ||
                                   value === '__EMPTY_GROUP__';
                          };
                        
                          // Check if this is the special empty group key or if field value should be dash
                          if (groupKey === '__EMPTY_GROUP__' || shouldShowDash(groupKey)) {
                            return <span>-</span>;
                          }
                        
                          // Get the first row to extract the field value (since all rows in a group should have the same grouping value)
                          const firstRow = childRows?.[0];
                          const fieldValue = firstRow?.[fieldName];
                        
                          // Double check the field value as well
                          if (shouldShowDash(fieldValue)) {
                            return <span>-</span>;
                          }
                        
                          if (fieldMeta?.type === "lookup") {
                            const lookupName = fieldValue;
                            const fullObject = firstRow?.[`${fieldName}_object`];
                            const parentObjectName = fieldMeta?.parent_object_name;
                            const redirectUrl = fullObject?._id
                              ? `/record/${parentObjectName}/${fullObject._id}`
                              : null;
                        
                            return (
                              <span
                                style={{
                                  color: redirectUrl ? "#00A1E0" : undefined,
                                  textDecoration: redirectUrl ? "underline" : undefined,
                                  cursor: redirectUrl ? "pointer" : undefined,
                                }}
                                onClick={() => redirectUrl && window.open(redirectUrl, "_blank")}
                              >
                                {lookupName}
                              </span>
                            );
                          }
                        
                          // Default for non-lookup group values
                          return <span>{fieldValue}</span>;
                        }
                        
                      }}
                    
                      // rowGrouper={(rows, columnKey) => _.groupBy(rows, columnKey)}
                      rowGrouper={(rows, columnKey) => {
                        console.log('Grouping by:', columnKey);
                        console.log('roewwsss::',rows);
                        
                        // Custom grouper to handle null/undefined/empty values
                        const grouped = _.groupBy(rows, (row) => {
                          const value = row[columnKey];
                          // Normalize null, undefined, empty string, 'null', 'undefined' to a consistent key
                          if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
                            return '-'; // Use a special key for empty values
                          }
                          return value;
                        });
                        
                        console.log('Grouped rows:', grouped);
                        console.log('rowData',rowData);

                        return grouped;
                      }}
                      
                      expandedGroupIds={expandedGroupIds}
                      onExpandedGroupIdsChange={setExpandedGroupIds}
                      className="rdg-light"
                      bottomSummaryRows={summaryRows}  // Pass the computed summary rows to the table
                    />
                   
                  </div>

                )}
              </Card>
              {showChart &&

                <Card>
                  <h2>{capitalizeFirstLetter(chartName)} Chart</h2>
                  {renderChart()}
                </Card>
              }
            </Content>

          </Layout>

        </Layout>

      </div>
    </div>
  );
};

export default DisplayReport;
